import type { Location } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { levelsList } from '../Location.Mappings';
import { inUseStatuses } from '../../utils/constants';
import { gql } from '@apollo/client';
import { getTenantList } from '#/graphql/queries';

const columns: ColumnProps<Location>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'name',
    caption: 'Name',
    dataType: 'string',
    visible: true,
    fixed: true,
    openOnClick: true,
  },
  {
    dataField: 'level',
    caption: 'Type',
    dataType: 'string',
    visible: true,
    lookup: {
      dataSource: levelsList,
      valueExpr: 'value',
      displayExpr: 'label',
    },
  },
  {
    dataField: 'parent.name',
    caption: 'Parent',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'inUseStatus',
    caption: 'Status',
    dataType: 'string',
    visible: false,
    lookup: {
      nullable: true,
      dataSource: Object.values(inUseStatuses),
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  {
    dataField: 'thirdPartyId',
    caption: 'Third Party ID',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'source',
    caption: 'Third Party Source',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    visible: true,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
];

export default columns;
